export default "__VITE_ASSET__DsGSJ0Ot__"